export const LOAD_ESTIMATES = 'LOAD_ESTIMATES'
export const ADD_ESTIMATE = 'ADD_ESTIMATE'
export const LOAD_ESTIMATE_STATUS = 'LOAD_ESTIMATE_STATUS'